<template>
  <!-- 商品列表 -->
  <div class="productAreaPrice">
    <!-- 页头 -->
    <page-bar @back="goBack" @refresh="handleRefresh" :title="$route.meta.title">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleEdit('')">添加</el-button>
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input v-model="searchForm.name" style="width:150px;margin-right:5px" clearable
          placeholder="输入编号/名称"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        type="selection"
        align="center"
        width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="编号">
      </el-table-column>
      <el-table-column
        prop="goodsId"
        align="center"
        show-overflow-tooltip
        label="商品编号">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        align="center"
        show-overflow-tooltip
        label="商品名称">
      </el-table-column>
      <el-table-column
        prop="userType"
        label="客户类型"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="area"
        label="区域"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="price"
        label="价格"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160">
        <template slot-scope="scope">
          <el-button type="primary" style="padding:2px 3px;" plain
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" style="padding:2px 3px;" plain
            @click="delTableData(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
    
    <!-- 区域价格 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">区域价格</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="客户类型" prop="userType">
              <el-checkbox-group v-model="addForm.userType" style="width: 100%">
                <el-checkbox v-for="(item,index) in userTypeList" :label="item.value" :key="index">
                  {{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="选择区域" prop="areaValue">
              <div class="area">
                <div class="area_List">
                  <el-tag 
                    v-for="(item,index) in areaList" 
                    :key="index" 
                    closable
                    @close="areaClose(index)"
                    type="success"
                    effect="dark"
                    :disable-transitions="false"
                    class="my-el-tag"
                    style="margin-bottom: 5px;">{{item.label}}
                  </el-tag>
                </div>
                <el-button type="primary" @click="getAearData('')">增加区域</el-button>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input-number v-model="addForm.price" style="width:100%;" :min="0"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <!-- 数据选择 -->
    <tableDialog 
      v-if="dialogVisible"
      :title="'区域选择'"
      :isMoreSel="true"
      :searchValue="searchArea.name"
      :tableData="tableDataList"
      :tableHead="tableDataHead"
      :currPage.sync="currPageDialog"
      :allPage="allPageDialog"
      @search="getAearData"
      @moreSel="selDataOk"
      @rowClick="rowClick"
      @hanCurrChange="hanCurrChangeDialog"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'productAreaPrice',
  mixins:[formatStatus],
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"区域价格id",
      //   goodsId:"商品编号",
      //   goodsName:"商品名称",
      //   userTypeId:"客户类型ID",
      //   userType:"客户类型",
      //   areaValue:"区域ID",
      //   area:"区域",
      //   price:"价格",
      // }
      tableData:[],
      goodsId: '',
      endId: '',
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
      /**搜索表单 */
      // 商品分类 商品属性 商品状态 库存状态 商品图片 活动专区 活动状态 商品名称
      searchForm:{
        name:""
      },
      /**select选中项 */
      selectedList:[],
      isRefresh: false,
      timer: null,
      /**新增drawer */
      addDrawer: false,
      /**新增表单 */
      addForm: {
        id: '',
        userType: [], // 客户类型
        areaValue: '', // 区域范围
        price: '', // 价格
      },
      /**新增表单规则 */
      addFormRule: {
        userType: [mustFill],
        areaValue: [mustFill],
        price: [mustFill],
      },
      userTypeList: [],
      areaList: [],
      // 区域选择弹窗相关
      dialogVisible: false,
      searchArea: {
        name: ''
      },
      tableDataList: [],
      tableDataHead: {},
      currPageDialog: 1,
      allPageDialog: 0,
      isSelDataOkRep: false,
    }
  },
  mounted(){
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      //执行编辑
      this.goodsId = prams.goodsId;
      this.endId = prams.entId;
      this.getTableData();
    }
    this.getUserType();
  },
  methods:{
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    /**获取表格 */
    getTableData(){
      let data = {
        entId: this.endId,
        articleId: this.goodsId,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      }
      this.$request({
        url: 'HTGoods/GetGoodsAreaPrice',
        method: 'post',
        data: data
      }).then((res) => {
        console.log(res);
        this.tableData = [];
        if (res.success) {
          this.tableData = res.list.map(item => {
            return {
              id: item.keyId,
              goodsId: item.article_id,
              goodsName: item.sub_title,
              userTypeId: item.ClientCode,
              userType: item.ClientName,
              areaValue: item.AreaCode,
              area: item.AreaName,
              price: item.Price,
            }
          })
          this.allPage = res.toTal;
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    // 获取客户类型
    getUserType(){
      let proc = "Proc_Admin_CustomerList";//存储过程名
      let type = "ReturnList";
      let json = {
        type: "CustomType"
      };
      this.$requestSys({
        method:"post",
        url: "coupon/ashx/returnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(json)) + "&proc=" + proc,
        dataType:"json"
      }).then((res) => {
        if (res.flag == 0) {
          this.userTypeList = res.data.map(item => ({label: item.clienttype,value: item.TypeID}))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**刷新表格数据 */
    handleRefresh(){
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val;
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
    /**selection change触发事件 */
    selectionChange(section){
      //存放选中的表格数据
      this.selectedList = section;
    },
    delTableData(row){
      this.$confirm('确定要删除吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          keyId: row.id
        };
        this.$request({
          url: 'HTGoods/DltGoodsAreaPrice',
          method:"post",
          data: data
        }).then((res) => {
          if(res.success){
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getTableData();
          }else{
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err);
        });
      }).catch(() => {});
    },
    /**点击编辑 */
    handleEdit(row) {
      this.clearForm()
      if(row){
        this.addForm.id = row.id
        this.addForm.userType = this.$changeStrArr(row.userTypeId)
        this.addForm.areaValue = row.areaValue
        this.addForm.price = row.price
        this.areaList = this.$changeStrArr(row.areaValue).map((item,index) => {
          return {value: item,label: this.$changeStrArr(row.area)[index]}
        })
      }
      this.addDrawer = true;
    },
    // 新增区域
    getAearData(val,isRep){
      this.searchArea.name = isRep ? val : this.searchArea.name
      let data = {
        type: 'RegionList',
        PageIndex: this.currPageDialog,
        PageSize: 10,
        strWhere: this.searchArea.name,
      };
      let proc = "Proc_Admin_SearchInfo";//存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method:"post",
        url: "ashx/MainReturnJson.ashx?json=" + encodeURIComponent(JSON.stringify(data)) + "&type=" + type + "&proc=" + proc,
      }).then((res) => {
        if (res.flag == 0) {
          this.tableDataList = res.content
          this.tableDataHead = res.fdname
          this.allPageDialog = res.recordCount
          this.dialogVisible = true
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    /**当前页改变 */
    hanCurrChangeDialog(val){
      this.currPageDialog = val;
      this.getAearData()
    },
    // 选择单条数据
    rowClick(row,isSelDataOk){
      for(let i = 0; i < this.areaList.length; i++){
        if(this.areaList[i].value == row.keyid){
          if(isSelDataOk === true){
            this.isSelDataOkRep = true
          }else{
            this.$message({
              message: '选择的数据已在列表中',
              type: 'warning'
            });
          }
          return
        }
      }
      this.areaList.push({
        label: row.地址,
        value: row.keyid
      })
      this.addForm.areaValue = this.areaList.map(item => item.value).join()
      this.dialogVisible = false
    },
    // 选择数据完成，多选
    selDataOk(selectedList){
      if(selectedList.length == 0){
        this.$message({
          message: '请选择数据',
          type: 'warning'
        });
        return
      }
      selectedList.forEach(item => {
        this.rowClick(item,true)
      })
      if(this.isSelDataOkRep){
        this.$message({
          message: '选择的数据已在列表中',
          type: 'warning'
        });
        this.isSelDataOkRep = false
      }
    },
    // 区域删除
    areaClose(index){
      this.areaList.splice(index,1)
      this.addForm.areaValue = this.areaList.map(item => item.value).join()
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      // this.$refs["addForm"].resetFields();
      this.addForm = {id: '',userType: [],areaValue: '',price: '',};
      this.areaList = [];
      this.addDrawer = false;
    },
    /**提交表单 */
    submit() {
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          let data = {
            keyId: this.addForm.id || '0',
            article_id : this.goodsId,
            ClientCode: this.addForm.userType.join(','),
            ClientName: this.addForm.userType.map(item => {
              let label = ''
              this.userTypeList.forEach(item1 => {
                if(item1.value == item){
                  label = item1.label
                }
              })
              return label
            }).join(','),
            AreaCode: this.addForm.areaValue,
            AreaName: this.areaList.map(item => item.label).join(','),
            Price: this.addForm.price,
          };
          this.$request({
            method:"post",
            url: 'HTGoods/SaveGoodsAreaPrice',
            data: data
          }).then((res) => {
            if(res.success){
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getTableData()
              this.clearForm()
            }else{
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err)
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.productAreaPrice{
  width: 100%;
  height: 100%;
}
.area_List{
  display: flex;
  flex-wrap:wrap;
  width: 100%;
}
</style>